import { Component } from "@angular/core";
import { InputManager } from "../game-engine/input-manager";
var actions = [
    "forward",
    "back",
    "left",
    "right",
    "jump",
    "action_1",
    "action_2",
    "action_3",
    "action_4",
    "action_5",
    "display_menu"
];
var SkillLog = (function () {
    function SkillLog(input_manager_) {
        this.input_manager_ = input_manager_;
        this.current_action = "";
        this.current_move = "";
    }
    ;
    SkillLog.decorators = [
        { type: Component, args: [{
                    selector: "skill-log",
                    template: "<p>move: {{current_move}}, action: {{current_action}}</p>",
                    styles: ["\n    "]
                },] },
    ];
    SkillLog.ctorParameters = function () { return [
        { type: InputManager, },
    ]; };
    return SkillLog;
}());
export { SkillLog };
;
//# sourceMappingURL=skill-log.component.js.map